import Places from "../pages/places/actives/pages/Places";
import PlaceDetails from "../pages/places/actives/pages/PlaceDetails";
import EditPlace from "../pages/places/actives/pages/EditPlace";
import Drafts from "../pages/places/drafrts/Drafts";
import DraftDetails from "../pages/places/drafrts/DraftDetails";
import Collections from "../pages/places/collections/Collections";
import CollectionDetails from "../pages/places/collections/CollectionDetails";
import EditCollection from "../pages/places/collections/EditCollection";
import CreateCollection from "../pages/places/collections/CreateCollection";
import AiDiscover from "../pages/places/ai-discover/AiDiscover";

export const placeRoutes = [
  { path: "/places/actives", element: <Places /> },
  { path: "/places/actives/:placeId", element: <PlaceDetails /> },
  { path: "/places/actives/:placeId/edit", element: <EditPlace /> },

  { path: "/places/drafts", element: <Drafts /> },
  { path: "/places/drafts/:draftId", element: <DraftDetails /> },

  { path: "/places/collections", element: <Collections /> },
  { path: "/places/collections/:collectionId", element: <CollectionDetails /> },
  {
    path: "/places/collections/:collectionId/edit",
    element: <EditCollection />,
  },
  { path: "/places/collections/create", element: <CreateCollection /> },

  { path: "/places/ai-discover", element: <AiDiscover /> },
];
